import * as React from 'react';
import {connect} from 'react-redux';

import type {NutshellState} from '../../../../store';

import type {ActiveItem} from '../../types';
import {getActiveItem, isActiveItemNew} from '../../ui-selectors';

import {AccountAssignmentEditor} from './account-assignment-editor';
import {ClosedLeadConstantContactSubscriptionEditorWrapper} from './closed-lead-constant-contact-subscription-editor-wrapper';
import {ClosedLeadFollowupRuleEditor} from './closed-lead-followup-rule-editor';
import {ClosedLeadMailChimpSubscriptionEditorWrapper} from './closed-lead-mailchimp-subscription-editor-wrapper';
import {ClosedLeadSlackEditor} from './closed-lead-slack-editor';
import {ClosedLeadStartTriggerSidebar} from './closed-lead-start-trigger-sidebar';
import {ConstantContactStageSubscriptionEditor} from './constant-contact-stage-subscription-editor';
import {EmailSequenceStageSubscriptionEditor} from './email-sequence-stage-subscription-editor';
import {GoalsEditor} from './goals-editor';
import {MailChimpStageSubscriptionEditor} from './mailchimp-stage-subscription-editor';
import {OpenLeadSlackEditor} from './open-lead-slack-editor';
import {StageEditor} from './stage-editor';
import {StepTemplateEditor} from './step-template-editor';
import {TaskTemplateEditor} from './task-template-editor';
import {TextAutomationEditor} from './text-automation-editor';
import {UserAssignmentEditor} from './user-assignment-editor';

type OwnProps = {
    stagesetId: string;
};

type StateProps = {
    activeItem: ActiveItem | null | undefined;
    isActiveItemNew: boolean;
};

type Props = OwnProps & StateProps;

const EDITORS = {
    emails: MailChimpStageSubscriptionEditor,
    constantContactEmails: ConstantContactStageSubscriptionEditor,
    nutshellEmailMarketing: EmailSequenceStageSubscriptionEditor,
    emailMarketingCta: null,
    goals: GoalsEditor,
    closedLeadSlackMessage: ClosedLeadSlackEditor,
    slack: OpenLeadSlackEditor,
    stages: StageEditor,
    stepTemplates: StepTemplateEditor,
    userAssignments: UserAssignmentEditor,
    textAutomations: TextAutomationEditor,
    closedLeadAccountTypeAutomations: AccountAssignmentEditor,
    closedLeadTaskTemplates: TaskTemplateEditor,
    closedLeadMailChimpSubscriptions: ClosedLeadMailChimpSubscriptionEditorWrapper,
    closedLeadConstantContactSubscriptions: ClosedLeadConstantContactSubscriptionEditorWrapper,
    closedLeadDripSequenceStartTriggers: ClosedLeadStartTriggerSidebar,
    closedLeadFollowupRule: ClosedLeadFollowupRuleEditor,
} as const;

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        activeItem: getActiveItem(state),
        isActiveItemNew: isActiveItemNew(state),
    };
};

function SalesAutomationEditorComponent(props: Props) {
    if (!props.activeItem || !EDITORS[props.activeItem.type]) return null;

    const Editor = EDITORS[props.activeItem.type];

    return (
        // @ts-expect-error
        <Editor stagesetId={props.stagesetId} isNew={props.isActiveItemNew} {...props.activeItem} />
    );
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const SalesAutomationEditor = connector(SalesAutomationEditorComponent);
